export default function PHP_each() {
  return (
    <div>
      <h1>PHP_each</h1>
    </div>
  );
}
